<template>
    <div class="art-cont">
                    <h1 class="fs28 lh38">“星火·链网”正式启动，面向全球服务的国家级区块链新型基础设施进入到建设阶段</h1>
                    <div class="title-info">2020-09-03</div>
                    <div class="main-content">
                        <p>
	8月30日下午，“工业互联网标识主题论坛”作为2020工业互联网大会的主题论坛之一，通过20余家直播平台在云端成功举办。论坛上举行了国家区块链与工业互联网协同新型基础设施——“星火·链网”启动仪式。
</p>
<p>
	<br>
</p>
<p>
	中国信息通信研究院工业互联网与物联网研究所所长金键首次介绍了“星火·链网”的设计理念与发展计划，这标志着“星火·链网”正式进入到建设阶段。“星火·链网”充分考虑了当前区块链的发展现状，基于公有许可链设计了双层体系架构，在提供新型工业互联网标识、公共数据资产的同时，可以通过下层的骨干节点实现现有区块链的广泛互通，进而逐步扩大区块链的使用规模和提升使用效果。“星火·链网”在工业互联网提出的全要素、全产业链、全价值链互联基础上，基于分布式标识技术完成资产的数字对象刻画，实现区块链与“物理经济体”的融合，加速培育数字经济的新生态体系。“星火·链网”具备开放的建设策略以及治理模式，定位于面向全球服务的国家级区块链新型基础设施。
</p>
<p>
	<br>
</p>
<p style="text-align:center;">
	<img src="/core/extend/kindeditor/attached/image/20220228/20220228171856_42656.jpg" alt="" ondragstart="return false"> 
</p>
<p style="text-align:center;">
	中国信息通信研究院工业互联网与物联网研究所所长 金键
</p>
<p>
	<br>
</p>
<p>
	论坛上，工业和信息化部信息通信管理局副局长鲁春丛、中国信息通信研究院院长刘多与中国工程院院士，电子商务与电子支付国家工程实验室主任、理事长柴洪峰；北京市经济和信息化局党组成员、副局长潘锋；上海市通信管理局党组书记、局长陈皆重；湖北省经济和信息化厅党组书记、厅长刘海军；重庆两江新区党工委副书记、管委会常务副主任王志杰；广州黄埔区委常委，区政府党组副书记、副区长毛松柏；贵阳市委常委、常务副市长徐昊；北京市顺义区委副书记、顺义区人民政府区长、党组书记孙军民；横琴新区党委书记、保税区党委书记牛敬；济南市副市长、市政府党组成员孙斌；漯河市委书记蒿慧杰；营口市委副书记、营口市政府党组书记、市长许桂清；苏州市相城区委书记顾海东；中国联合网络通信集团有限公司副总经理梁宝俊梁宝俊；国网电子商务有限公司董事、总经理、党委副书记闫华锋；北京邮电大学副校长王文博；北京航空航天大学计算机学院院长吕卫锋；中国信息通信研究院副院长余晓晖，共20名领导和专家共同启动了“星火·链网”。
</p>
<p>
	<br>
</p>
<p style="text-align:center;">
	<img src="/core/extend/kindeditor/attached/image/20220228/20220228171939_22200.jpg" alt="" ondragstart="return false"> 
</p>
<p style="text-align:center;">
	国家新型基础设施——“星火·链网”的启动仪式
</p>
                    </div>
                    <div class="art-bott flex flex-wrap-wrap flex-justify-between flex-align-center">
                        <a href="/News/1" class="art-btn btn-hvr" ondragstart="return false">返回</a>
                        
                    </div>
                    <div class="arc-nav">
                        <a href="/NewsDetail/65" ondragstart="return false">上一条 :  推动湾区品质认证，打造“澳门监制”平台</a>
                        <a href="javascript:;" ondragstart="return false">下一条 : 没有了！</a>
                    </div>
                </div>
</template>
  
  <script setup>
  import { ref, onMounted, onUnmounted } from 'vue';
  
  const startAnimate = ref(false)


  onMounted(() => {
    startAnimate.value = true
  });
  
  onUnmounted(() => {
    startAnimate.value = false
  });
  </script>
  
  <style scoped>
 .article .art-cont {
    background: #fff;
    width: calc(70% - 80px);
    padding: 50px 40px;
    overflow: hidden;
    border-radius: 8px;
}
.article .art-cont h1 {
    color: #333;
    font-weight: 700;
}
    .article .art-cont h1 {
        font-size: 26px;
    }

    .article .art-cont .title-info {
        font-size: 14px;
        color: #888;
        font-family: OPPOSans-H;
        padding-left: 30px;
        height: 20px;
        line-height: 22px;
        background: url(@/assets/images/news-time.png) no-repeat left center;
        margin: 30px 0;
    }

    .article .art-bott {
        margin-top: 50px;
        display: flex;
        justify-content: space-between;
        padding-bottom: 30px;
        margin-bottom: 30px;
        border-bottom: 1px solid #f0f0f0;
        align-items: center;
    }
    .article .art-bott .art-btn {
        background: #ea5413;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 110px;
        height: 42px;
        font-weight: 700;
        color: #fff;
        border-radius: 30px;
        transition: all .4s ease;
        font-size: 16px;
    }
    .btn-hvr:hover {
        border-color: transparent;
        box-shadow: 0 0 0 .2rem rgba(234, 84, 19, .5);
    }
    .article .arc-nav a {
        position: relative;
        display: block;
        font-size: 14px;
        color: #666;
        padding-left: 15px;
        transition: all .4s ease;
        font-weight: 700;
    }

  </style>